import { useCallback } from 'react'

import {
  useCreateSelectOptionRelationshipMutation,
  useGetSelectOptionRelationshipsQuery,
  useRemoveSelectOptionRelationshipMutation
} from '../services/selectOptionRelationships'

export function useManageOptionRelationships({ fieldId }) {
  const { data, isLoading } = useGetSelectOptionRelationshipsQuery({ fieldId }, { skip: !fieldId })

  const [createSelectOptionRelationship] = useCreateSelectOptionRelationshipMutation()
  const [removeSelectOptionRelationship] = useRemoveSelectOptionRelationshipMutation()

  const manageSelectOptionRelationship = useCallback(
    async ({ fieldRelationshipId, relatedOptionId, mainOptionId, fieldId }) => {
      let payload = { fieldRelationshipId, mainOptionId }

      if (relatedOptionId) {
        payload.relatedOptionId = relatedOptionId
        await createSelectOptionRelationship({ payload, fieldId })
      } else {
        await removeSelectOptionRelationship({ payload, fieldId })
      }
    },
    [createSelectOptionRelationship, removeSelectOptionRelationship]
  )

  return {
    optionRelationships: data,
    isLoading,
    manageSelectOptionRelationship
  }
}
